<template>
  <div class="homePc">
    <img class="homePcImage" src="@/assets/image/pcBg.png" />
    <div class="contentBox">
      <div class="leftBox">
        <img class="phoneImg" src="@/assets/image/phoneBg.png" />
      </div>
      <div class="rightBox">
        <img class="titleImg" src="@/assets/image/phoneTitle.png" />
        <div class="codeBox">
          <div class="leftCodeBox">
            <img :src="'https://static.crypts.cn/appDownload/andriod_download.png'" class="adCode" /><br />
            <img src="@/assets/image/ad_pc_btn.png" @click="goAd" class="adBtn" />
          </div>
          <div class="rightCodeBox">
            <img :src="'https://static.crypts.cn/appDownload/ios_download.png'" class="adCode" /><br />
            <img src="@/assets/image/ios_pc_btn.png" @click="goIos" class="adBtn" />
          </div>
        </div>
        <p class="tipText">请用手机浏览器扫码下载</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlKey } from '@/utils/utils'

export default {
  name: "homePc",
  props: {
    msg: String
  },
  data() {
    return {
      count: 0
    };
  },
  mounted() {
    // console.log(this.$analytics);

  },
  methods: {
    goIos() {
      window.open("https://itunes.apple.com/cn/app/id1575026717");
      let channel = getUrlKey("download_channel");
      console.log(channel);
      setTimeout(() => {
        // console.log(window._hmt);
        window['_hmt'].push(['_trackEvent', 'pc_ios_download_btn_click', channel === '1' ? '1' : '0']);
      }, 3000);
    },
    goAd() {
      let channel = getUrlKey("download_channel");
      console.log(channel);

      setTimeout(() => {
        // console.log(window._hmt);
        window['_hmt'].push(['_trackEvent', 'pc_android_download_btn_click', channel === '1' ? '1' : '0']);
      }, 3000);
      window.open(
        "https://app.crypts.cn/appDownload/singular_fire_app_release.apk");
    },
    sum(m, n) {
      var num = Math.floor(Math.random() * (m - n) + n);
      return num;
    }
  }
};
</script>

<style scoped lang="scss">
.homePc {
  width: 100%;
  height: 100%;

  .homePcImage {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .contentBox {
    height: 585px;
    width: 1160px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;

    .leftBox {
      .phoneImg {
        width: 625px;
        height: 750px;
        object-fit: contain;
        position: relative;
        top: -60px;
      }
    }

    .rightBox {
      margin-left: 60px;

      .titleImg {
        width: 400px;
        height: 133px;
        object-fit: contain;
        margin-left: 28px;
      }

      .tipText {
        color: rgba($color: white, $alpha: 0.5);
        font-size: 14px;
        margin-top: 20px;
        text-align: center;
      }

      .codeBox {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-top: 100px;

        .leftCodeBox,
        .rightCodeBox {
          .adCode {
            width: 182px;
            height: 182px;
            object-fit: contain;
          }

          .adBtn {
            width: 242px;
            height: 60px;
            object-fit: contain;
            margin-top: 30px;
          }
        }

        .rightCodeBox {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
